<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-back-button="false"
        :with-primary-buttons="false"
    >
        <kgr-club-sales-list-evaluation
            :club-id="clubId"
            :payment-methods="paymentMethods"
            :can-see-employees="canSeeEmployees"
            :error="error"
        />
    </kgr-form-scaffold>
</template>

<script>
import ClubSalesListEvaluationForm from '../../../components/club/sales-list/ClubSalesListEvaluationForm.vue';
import Error from '../../../js/model/Error.js';
import FormScaffold from '../../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-club-sales-list-evaluation': ClubSalesListEvaluationForm,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        paymentMethods: {
            type: Array,
            required: true,
        },
        canSeeEmployees: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            pending: false,
        };
    },
    computed: {
    },
    methods: {},
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
